import { CSvgChart } from "icon"


export const OverViewChart = () => {




    return (
        <div className="w-full mb-4 flex items-center flex-wrap">
            <div className="md:w-6/12 w-full  md:pr-[10px] mb-4 md:mb-0 pr-0 flex items-center justify-center">
                <div className="w-full  bg-hoory-100 rounded-lg flex flex-col md:p-[20px] p-[10px]">
                    <h3>Open Conversations</h3>
                    <div className="w-full flex items-center mt-[20px]">
                        <div className="w-full  flex flex-col items-center justify-center">
                            <CSvgChart className="md:w-[45px] w-[30px] fill-hoory-200" />
                            <span className="my-1 md:text-base text-sm">250</span>
                            <span className="text-gray-400 text-xs">Watch Sale </span>
                        </div>
                        <div className="w-full  flex flex-col items-center justify-center">
                            <CSvgChart className="md:w-[45px] w-[30px] fill-[gold]" />
                            <span className="my-1 md:text-base text-sm">1120</span>
                            <span className="text-gray-400 text-xs">Phone Sale </span>
                        </div>
                        <div className="w-full  flex flex-col items-center justify-center">
                            <CSvgChart className="md:w-[45px] w-[30px] fill-[tomato]" />
                            <span className="my-1 md:text-base text-sm">530</span>
                            <span className="text-gray-400 text-xs">Tablet Sale </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="md:w-6/12 w-full md:pl-[10px] pl-0 flex items-center justify-center">
                <div className="w-full  bg-hoory-100 rounded-lg flex flex-col md:p-[20px] p-[10px]">
                    <h3>Agent status</h3>
                    <div className="w-full flex items-center mt-[20px]">
                        <div className="w-full  flex flex-col items-center justify-center">
                            <CSvgChart className="md:w-[45px] w-[30px] fill-hoory-200" />
                            <span className="my-1 md:text-base text-sm">250</span>
                            <span className="text-gray-400 text-xs">Online </span>
                        </div>
                        <div className="w-full  flex flex-col items-center justify-center">
                            <CSvgChart className="md:w-[45px] w-[30px] fill-[gold]" />
                            <span className="my-1 md:text-base text-sm">1120</span>
                            <span className="text-gray-400 text-xs">Busy</span>
                        </div>
                        <div className="w-full  flex flex-col items-center justify-center">
                            <CSvgChart className="md:w-[45px] w-[30px] fill-[tomato]" />
                            <span className="my-1 md:text-base text-sm">530</span>
                            <span className="text-gray-400 text-xs">Offline </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}